import { useState } from 'react';
import type { DecorLibraryItem } from '@peles/shared';
import { useVendorDecorPieces } from '../../hooks/useDecorLibrary';
import { DecorLibraryCard } from './DecorLibraryCard';
import { DecorLibraryItemModal } from './DecorLibraryItemModal';

const PAGE = 12;

/** The decor library pieces a vendor supplies, on the vendor's page. */
export function VendorDecorPieces({ vendorId }: { vendorId: string }) {
  const pieces = useVendorDecorPieces(vendorId);
  const [editing, setEditing] = useState<DecorLibraryItem | null>(null);
  const [limit, setLimit] = useState(PAGE);

  if (pieces.isLoading) {
    return (
      <div
        className="h-32 animate-pulse rounded-xl bg-gray-100"
        data-testid="vendor-decor-loading"
      />
    );
  }
  if (pieces.isError) {
    return <p className="text-sm text-red-600">The decor pieces could not be loaded.</p>;
  }
  const list = pieces.data ?? [];
  if (list.length === 0) {
    return (
      <p className="text-sm text-gray-500">
        No decor pieces name this vendor yet. Add them in Settings → Decor Library, or from the
        floor plan’s library.
      </p>
    );
  }
  return (
    <div className="space-y-3">
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
        {list.slice(0, limit).map((item) => (
          <DecorLibraryCard key={item.id} item={item} pressLabel="Edit" onPress={setEditing} />
        ))}
      </div>
      {list.length > limit && (
        <button
          type="button"
          onClick={() => setLimit((n) => n + PAGE)}
          className="min-h-11 sm:min-h-9 rounded-lg border border-gray-300 px-4 text-sm text-gray-700 hover:bg-gray-50"
        >
          Show more ({list.length - limit} left)
        </button>
      )}
      <DecorLibraryItemModal open={!!editing} onClose={() => setEditing(null)} item={editing} />
    </div>
  );
}
